<h1 mat-dialog-title *ngIf="data?.title">{{ data.title }}</h1>
<div mat-dialog-content>
  <div class="container-fluid">
    <!-- <div class="row">
      <div class="col-12">
      </div>
    </div>
  </div> -->
  </div>
</div>
<div mat-dialog-actions>
  <button
    role="button"
    type="button"
    aria-label="Download Now"
    mat-button
    (click)="download()"
    cdkFocusInitial
  >
    Download Now
  </button>
  <button
    role="button"
    type="button"
    aria-label="Download Later"
    mat-button
    (click)="dialogRef.close('no')"
  >
    Download Later
  </button>
</div>
